import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import {
  getDashboardUrl,
  getInvoiceUrl,
  isStripeInvoice,
  useIsAdmin,
  useSessionInvoices,
} from '@app/api';

import { InvoiceStatusChip, Link, TitleWithIcon } from 'components';
import { toEuros } from '@app/i18n';
import { useTranslation } from 'react-i18next';

const useStyles = createUseStyles((theme: Theme) => ({
  invoices: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.marginBase * 2,
  },
  invoice: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.marginBase * 2,
    ...theme.fonts.caption,
    color: theme.colors.inkSecondary,
  },
  name: {},
  spacer: {
    flex: 1,
  },
  status: {},
  price: {
    ...theme.fonts.caption,
    textAlign: 'right',
  },
  link: {
    ...theme.fonts.caption,
    color: theme.colors.blueAccessible,
  },
}));

interface Props {
  sessionId: string;
}
export const SessionInvoices = ({ sessionId }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { data: invoices } = useSessionInvoices(sessionId);
  const isAdmin = useIsAdmin();

  return (
    <div>
      <TitleWithIcon
        icon="ri-file-list-3-line"
        iconColor="green"
        title={t('billing.billingDetails.invoices')}
      />
      <div className={classes.invoices}>
        {invoices?.map((invoice) => (
          <div className={classes.invoice}>
            <div className={classes.name}>{invoice.name}</div>
            <div className={classes.status}>
              <InvoiceStatusChip status={invoice.status} />
            </div>
            <div className={classes.spacer} />
            <div className={classes.price}>
              {invoice.totalHT !== undefined ? toEuros(invoice.totalHT) : ''}
              {invoice.tax && invoice.totalHT !== undefined ? ' HT' : ''}
            </div>
            <div className={classes.price}>
              {invoice.tax && invoice.total !== undefined
                ? toEuros(invoice.total) + ' TTC'
                : ''}
            </div>
            {isAdmin &&
              invoice.totalHT === 0 &&
              invoice.creditUsageTotal &&
              toEuros(invoice.creditUsageTotal) + ' de crédits'}

            {isAdmin && getDashboardUrl(invoice) && (
              <Link
                href={getDashboardUrl(invoice)}
                target="_blank"
                rel="noopener noreferrer"
                className={classes.link}
                isExternalLink
              >
                Modifier la facture
              </Link>
            )}
            {getInvoiceUrl(invoice) && (
              <Link
                href={getInvoiceUrl(invoice)}
                target="_blank"
                rel="noopener noreferrer"
                className={classes.link}
                isExternalLink
              >
                {t('billing.invoice.see')}
              </Link>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
